export const compareMemberStatus = (
  userId: string,
  originalMembers: readonly string[],
  currentMembers: string[]
) => {
  const originalHasUser = originalMembers?.includes(userId);
  const currentHasUser = currentMembers?.includes(userId);

  if (originalHasUser && currentHasUser) {
    // 当前和原来都有该用户
    return 0;
  }
  if (currentHasUser && !originalHasUser) {
    // 当前成员新加入
    return 1;
  }
  if (!currentHasUser && originalHasUser) {
    // 当前成员被移除
    return 2;
  }
  // 其他情况
  return -1;
};
